import { BueroType } from '../../../../../types/Survey/Analysis/Calculation'
import { Concept } from '../../../../../types/Survey/Analysis/Concept'
import { BueroTypeResult, ResultPropsGeneric } from '../../../../../types/Survey/Analysis/FactorValues'
import { getPercentage } from '../../../../../utility'

const getVerkehrsflaechen = (result: BueroTypeResult, concept: Concept, bueroType: BueroType): ResultPropsGeneric => {
  let practicalQM = getPercentage(result.total, concept.optimization.verkehrsflaechenPercentage)

  if (bueroType === BueroType.ZELLSTRUKTUR) {
    practicalQM = getPercentage(
      result.total -
        result.EINZELARBEIT.KLASSISCHE_ARBEIT.practicalQM -
        result.EINZELARBEIT.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR.practicalQM -
        result.EINZELARBEIT.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR.practicalQM,
      concept.optimization.verkehrsflaechenPercentage,
    )
  }
  return {
    practicalQM,
  }
}

export default getVerkehrsflaechen
